module.exports = __webpack_public_path__ + "fontawesome-webfont.674f50d287a8c48dc19b.eot";


//////////////////
// WEBPACK FOOTER
// ./font-awesome-4.7.0/fonts/fontawesome-webfont.eot?v=4.7.0
// module id = 250
// module chunks = 2